<template>
  <div class="Tools container-fluid">
    <div class="row">
        <div class="col-3 test">
          <div class="row">
            <div class="col">
                <div class="toolElement">
                    <button class="btn_tools LocalizeLinks" v-on:click="toggleNameTool('LocalizeLinks')">Localized Links</button><br>
                    <button class="btn_tools Lookahead" v-on:click="toggleNameTool('Lookahead')">Lookahead jira</button>
                    <button class="btn_tools Overlay" v-on:click="toggleNameTool('Overlay')">Overlay</button>
                    <button class="btn_tools QRcodes" v-on:click="toggleNameTool('QRcodes')">QRcodes Creator</button>
                    <button class="btn_tools RenamingFiles" v-on:click="toggleNameTool('RenamingFiles')">Renaming Files</button>
                </div>
            </div>
          </div>
        </div>
        <div class="col-9 mainBar">
          <div v-if="getName == 'LocalizeLinks'">
            <LocalizedLinks></LocalizedLinks>
          </div>
          <div v-else-if="getName == 'QRcodes'">
            <QRcode></QRcode>
          </div>
          <div v-else-if="getName == 'RenamingFiles'">
            <RenamingFiles></RenamingFiles>
          </div>
          <div v-else-if="getName == 'Overlay'">
            <Overlay></Overlay>
          </div>
          <div v-else-if="getName == 'Lookahead'">
            <Lookahead-jira></Lookahead-jira>
          </div>
        </div>


    </div>
  </div>
</template>

<script>
import LocalizedLinks from './Tools/LocalizedLinks'
import Lookahead_jira from './Tools/Lookahead_jira'
import Overlay from './Tools/Overlay'
import RenamingFiles from './Tools/RenamingFiles'
import QRcode from './Tools/QRcode'
export default {
  name: 'Tools',
  components:{
    'LocalizedLinks':LocalizedLinks,
    'Lookahead-jira':Lookahead_jira,
    'Overlay': Overlay,
    'RenamingFiles':RenamingFiles,
    'QRcode':QRcode
  },
  data:() =>({
    selectedTool: "LocalizeLinks",
  }),
  methods:{
    toggleNameTool: function(name){
        this.selectedTool = name
    }
  },
  computed:{
    getName: function(){
      return this.selectedTool
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Pacifico&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Righteous&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Fredoka+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Geo&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Leckerli+One&display=swap');

.Tools{
  font-family: 'Roboto', sans-serif;
  max-width: 700px;
  white-space:pre-wrap;
}
.topText{
  display: block;
}
.title{
  text-align:center;
  font-weight: 700;
  font-size: 1.5em;
  margin-bottom: 2%;
}
.techUsed{
  font-style: italic;
  font-weight: 100;
  font-size: 0.8em;
  text-align: justify;
  margin-bottom: 3%;
}
.content{
  text-align: justify;
  margin-bottom: 4%;
  text-align: justify;
  font-size: 0.9em;
}
.screenshots{
  text-align:center;
  margin-left: 20%;
  margin-right: 20%;
  padding-bottom: 3%;
  height: auto;
}
.LocalizeLinks{
  font-family: 'Righteous', cursive;
  margin:20px 20px 0px 20px;
  font-size: 18px;
  line-height: 1.1;
}
.Lookahead{
  font-family: 'Leckerli One', cursive;
  margin:20px 20px 0px 20px;
  font-size: 17px;
  line-height: 1.1;
}
.Overlay{
  font-family: 'Vibur', cursive;
  margin:20px 35px 0px 35px;
  font-size: 20px; 
}
.QRcodes{
  font-family: 'Fredoka One', cursive;
  margin:20px 20px 0px 20px;
  font-size: 20px; 
  line-height: 1.1;
}
.RenamingFiles{
  font-family: 'Geo', sans-serif;
  margin:20px 20px 0px 20px;
  font-size: 20px; 
    line-height: 1;
}
.btn_tools{
  border: none;
  color: rgb(255, 255, 255);
  background-color: black;
  padding: 5px 10px;
  text-align: center;
  cursor: pointer;
  outline: none;
  border-radius: 5px;
  box-shadow: 0px 2px 2px rgb(214, 213, 213);
}
.btn_tools:hover {
  background-color: rgb(83, 83, 83);
  transform: translateY(-2px);
}
.btn_tools:active{
  transform: translateY(4px);
  background-color: rgb(0, 0, 0);
  color:white;
}
.issues{
  text-align: center;
}
img{
  width:100%;
  height: 100%;
}
</style>
